
export const ErgonomicsCard = ({ children }) => {

  return (
    <div className="bg-perception-black-800 w-full h-full rounded-md overflow-hidden">
      {children}
    </div>
  );
};